import React, { useContext, useEffect } from "react"; 
import { AsMoneyShort } from "../../../../functions/AsMoney";
import { useSelector } from "react-redux";

const StartBal = ({ index }) => { 

  const id = useSelector((state) => state.units.items[index].id);
  const startBal = useSelector(
    (state) => state.units.items[index].shadow.startBal
  );

  const colWidth = useSelector((state) => state.uo.col.widthsInputs.startBal);
  const justCol = useSelector((state) => state.uo.col.justData.startBal);
  const edit = useSelector((state) => state.uo.edit.id);

  const h = useSelector((state) => state.ui.h);

  useEffect(() => {}, []);

  return (
    <div
      className={`flex-none relative whitespace-pre ${justCol} shrink ${h.line} text-right mr-1 ${ startBal} ${colWidth} `}
    > 
        {AsMoneyShort(startBal,true, 9)}
    </div>
  );
};

export default StartBal;
